export default __webpack_public_path__ + "static/media/KK_logo_keskitetty_eng_white.6d35f715.png";